import React, { useEffect, useState, createContext, useContext, ReactNode } from 'react';
import { translations, Language, TranslationKey } from './translations';
import { LocalizedString } from './contentStore';
interface LanguageContextType {
  language: Language;
  setLanguage: (lang: Language) => void;
  t: (key: TranslationKey, params?: Record<string, string>) => string;
  loc: (ls: LocalizedString) => string;
}
const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
export function LanguageProvider({
  children
}: {
  children: ReactNode;
}) {
  const [language, setLanguageState] = useState<Language>('ru');
  useEffect(() => {
    const saved = localStorage.getItem('yb_language') as Language;
    if (saved && (saved === 'ru' || saved === 'ky')) {
      setLanguageState(saved);
    }
  }, []);
  const setLanguage = (lang: Language) => {
    setLanguageState(lang);
    localStorage.setItem('yb_language', lang);
  };
  const t = (key: TranslationKey, params?: Record<string, string>): string => {
    let text = translations[language][key] || translations['ru'][key] || key;
    if (params) {
      Object.entries(params).forEach(([k, v]) => {
        text = text.replace(`{${k}}`, v);
      });
    }
    return text;
  };
  const loc = (ls: LocalizedString): string => {
    if (!ls) return '';
    return ls[language] || ls['ru'] || '';
  };
  return <LanguageContext.Provider value={{
    language,
    setLanguage,
    t,
    loc
  }} data-id="element-1202">
      
      {children}
    </LanguageContext.Provider>;
}
export function useLanguage() {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}